import html2canvas from "html2canvas";

export const getImageFromHtml = async (element: HTMLDivElement) => {
    const canvasElement = await html2canvas(element, {
        onclone: async (cloneDoc: Document) => {
            const imageElements = cloneDoc.querySelectorAll('image');

            for (let index = 0; index < imageElements.length; index++) {
                const imageElement = imageElements[index];

                const href = imageElement.getAttribute('href');

                if (href) {
                    const base64Image = await convertImageToBase64(href);

                    imageElement.setAttribute('href', base64Image);
                }
            }
        },
        allowTaint: true,
        useCORS: true,
        backgroundColor: null,
    });

    return canvasElement.toDataURL();
}

const convertImageToBase64 = async (url: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'Anonymous';

        image.onload = () => {
            const canvas = document.createElement('canvas');

            canvas.width = image.width;
            canvas.height = image.height;

            const ctx = canvas.getContext('2d');

            if (ctx) {
                ctx.drawImage(image, 0, 0);

                const dataURL = canvas.toDataURL();

                resolve(dataURL);
            }
        };

        image.onerror = reject;
        image.src = url;
    });
}

//* функция нужна для отладки, просмотра изображения
export const downloadImage = (dataURL: string) => {
    const link = document.createElement('a');

    link.href = dataURL;
    link.download = 'screenshot.png';

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
}
